var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h4", [_vm._v(" Image ")]),
    _vm._v(" "),
    _vm.activeImage
      ? _c("div", { staticClass: "my-3" }, [
          _c("div", { staticClass: "fields-wrapper is-divider" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-6" }, [
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "col-sm-3 col-form-label",
                        attrs: { for: "animation_selector" }
                      },
                      [_vm._v("\n              Image Selector\n            ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.activeImage.objectDbHash,
                              expression: "activeImage.objectDbHash"
                            }
                          ],
                          staticClass: "custom-select",
                          attrs: { id: "animation_selector" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.activeImage,
                                  "objectDbHash",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              function($event) {
                                return _vm.changeSelectedImage(_vm.event)
                              }
                            ]
                          }
                        },
                        _vm._l(_vm.getMediaImages, function(
                          imageSelector,
                          key
                        ) {
                          return _c(
                            "option",
                            {
                              key: key,
                              staticClass: "custom-select",
                              domProps: { value: key }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(imageSelector.name) +
                                  "\n                "
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                      _vm._v("\n              Display Type\n            ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.activeImage.displayType,
                              expression: "activeImage.displayType"
                            }
                          ],
                          staticClass: "custom-select",
                          attrs: { placeholder: "Select Media Type" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.activeImage,
                                "displayType",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { value: "Scene" } }, [
                            _vm._v("Scene")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "Screen" } }, [
                            _vm._v("Screen")
                          ])
                        ]
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "col-sm-3 col-form-label",
                        attrs: { for: "start_time" }
                      },
                      [_vm._v("\n              Start Time\n            ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.activeImage.startTime,
                            expression: "activeImage.startTime"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "start_time" },
                        domProps: { value: _vm.activeImage.startTime },
                        on: {
                          change: _vm.changeTime,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.activeImage,
                              "startTime",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "col-sm-3 col-form-label",
                        attrs: { for: "end_time" }
                      },
                      [_vm._v("\n              End Time\n            ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.activeImage.endTime,
                            expression: "activeImage.endTime"
                          }
                        ],
                        staticClass: "form-control",
                        attrs: { type: "text", id: "end_time" },
                        domProps: { value: _vm.activeImage.endTime },
                        on: {
                          change: _vm.changeTime,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.activeImage,
                              "endTime",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                      _vm._v("\n              Duration\n            ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c("input", {
                        staticClass: "form-control",
                        class: {
                          "border-danger":
                            (
                              parseFloat(_vm.activeImage.endTime) -
                              parseFloat(_vm.activeImage.startTime)
                            ).toFixed(2) <= 0
                        },
                        attrs: {
                          type: "text",
                          id: "image_duration_e",
                          readonly: ""
                        },
                        domProps: {
                          value: (
                            parseFloat(_vm.activeImage.endTime) -
                            parseFloat(_vm.activeImage.startTime)
                          ).toFixed(2)
                        }
                      })
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c("label", { staticClass: "col-sm-3 col-form-label" }, [
                      _vm._v("\n              Media size\n            ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-9" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-start" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "col-6 d-flex justify-content-start"
                            },
                            [
                              _c("span", { staticClass: "p-2" }, [
                                _vm._v("Width")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.activeImage.objectSizeDelta.width,
                                    expression:
                                      "activeImage.objectSizeDelta.width"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "number", id: "mediaWidth" },
                                domProps: {
                                  value: _vm.activeImage.objectSizeDelta.width
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.activeImage.objectSizeDelta,
                                      "width",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "col-6 d-flex justify-content-start"
                            },
                            [
                              _c("span", { staticClass: "p-2" }, [
                                _vm._v("Height")
                              ]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.activeImage.objectSizeDelta.height,
                                    expression:
                                      "activeImage.objectSizeDelta.height"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: { type: "number", id: "mediaHeight" },
                                domProps: {
                                  value: _vm.activeImage.objectSizeDelta.height
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.activeImage.objectSizeDelta,
                                      "height",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          )
                        ]
                      )
                    ])
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-6" }, [
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                      _vm._v("\n              Scale\n            ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-8" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.activeImage.scale,
                            expression: "activeImage.scale"
                          }
                        ],
                        attrs: {
                          type: "range",
                          min: "0",
                          max: "1",
                          step: "0.1"
                        },
                        domProps: { value: _vm.activeImage.scale },
                        on: {
                          __r: function($event) {
                            return _vm.$set(
                              _vm.activeImage,
                              "scale",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-2" }, [
                        _vm._v(_vm._s(_vm.activeImage.scale))
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row form-group align-items-center" },
                  [
                    _c("label", { staticClass: "col-sm-4 col-form-label" }, [
                      _vm._v("\n              Layer\n            ")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "btn-group dropright col-sm-4" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-light dropdown-toggle",
                          attrs: {
                            type: "button",
                            "data-toggle": "dropdown",
                            "aria-haspopup": "true",
                            "aria-expanded": "false"
                          }
                        },
                        [
                          _vm._v(
                            "\n                Select an action\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "dropdown-menu" }, [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            class:
                              _vm.activeImage.layer >= _vm.layerStep
                                ? "disabled action-disabled"
                                : "",
                            on: {
                              click: function($event) {
                                return _vm.bringToFront()
                              }
                            }
                          },
                          [_vm._v("Bring to front")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            class:
                              _vm.activeImage.layer >= _vm.layerStep
                                ? "disabled action-disabled"
                                : "",
                            on: {
                              click: function($event) {
                                return _vm.changeLayer(1)
                              }
                            }
                          },
                          [_vm._v("Bring forward")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            class:
                              _vm.activeImage.layer <= -_vm.layerStep
                                ? "disabled action-disabled"
                                : "",
                            on: {
                              click: function($event) {
                                return _vm.changeLayer(-1)
                              }
                            }
                          },
                          [_vm._v("Send backward")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            class:
                              _vm.activeImage.layer <= -_vm.layerStep
                                ? "disabled action-disabled"
                                : "",
                            on: {
                              click: function($event) {
                                return _vm.sendToBack()
                              }
                            }
                          },
                          [_vm._v("Send to back")]
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.activeImage.displayType === "Screen"
                  ? _c(
                      "div",
                      { staticClass: "row form-group align-items-center py-3" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-4 col-form-label" },
                          [_vm._v("\n              Alignment\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-8 align-items-center" },
                          [
                            _c("Icon", {
                              staticClass: "cursor-pointer mr-1",
                              attrs: {
                                icon: "align_left",
                                color:
                                  _vm.activeImage.objectTransformSimple
                                    .horizontal == "left"
                                    ? "Dodgerblue"
                                    : "white"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.horizontalAlignment("left")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("Icon", {
                              staticClass: "cursor-pointer mr-1",
                              attrs: {
                                icon: "align_center",
                                color:
                                  _vm.activeImage.objectTransformSimple
                                    .horizontal == "center"
                                    ? "Dodgerblue"
                                    : "white"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.horizontalAlignment("center")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("Icon", {
                              staticClass: "cursor-pointer mr-4",
                              attrs: {
                                icon: "align_right",
                                color:
                                  _vm.activeImage.objectTransformSimple
                                    .horizontal == "right"
                                    ? "Dodgerblue"
                                    : "white"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.horizontalAlignment("right")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("Icon", {
                              staticClass: "cursor-pointer mr-1",
                              attrs: {
                                icon: "align_bottom",
                                color:
                                  _vm.activeImage.objectTransformSimple
                                    .vertical == "bottom"
                                    ? "Dodgerblue"
                                    : "white"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.verticalAlignment("bottom")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("Icon", {
                              staticClass: "cursor-pointer mr-1",
                              attrs: {
                                icon: "align_middle",
                                color:
                                  _vm.activeImage.objectTransformSimple
                                    .vertical == "center"
                                    ? "Dodgerblue"
                                    : "white"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.verticalAlignment("center")
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("Icon", {
                              staticClass: "cursor-pointer mr-1",
                              attrs: {
                                icon: "align_top",
                                color:
                                  _vm.activeImage.objectTransformSimple
                                    .vertical == "top"
                                    ? "Dodgerblue"
                                    : "white"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.verticalAlignment("top")
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeImage.displayType === "Screen"
                  ? _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-4 col-form-label" },
                          [
                            _vm._v(
                              "\n              Offset Horizontal\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-8" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.activeImage.objectTransformSimple
                                    .offsetHorizontal,
                                expression:
                                  "activeImage.objectTransformSimple.offsetHorizontal"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", id: "offset-horizontal" },
                            domProps: {
                              value:
                                _vm.activeImage.objectTransformSimple
                                  .offsetHorizontal
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.activeImage.objectTransformSimple,
                                  "offsetHorizontal",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeImage.displayType === "Screen"
                  ? _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-4 col-form-label" },
                          [
                            _vm._v(
                              "\n              Offset Vertical\n            "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-8" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.activeImage.objectTransformSimple
                                    .offsetVertical,
                                expression:
                                  "activeImage.objectTransformSimple.offsetVertical"
                              }
                            ],
                            staticClass: "form-control",
                            attrs: { type: "text", id: "offset-vertical" },
                            domProps: {
                              value:
                                _vm.activeImage.objectTransformSimple
                                  .offsetVertical
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.activeImage.objectTransformSimple,
                                  "offsetVertical",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeImage.displayType === "Scene"
                  ? _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-4 col-form-label" },
                          [_vm._v("Position of Origin")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-8" }, [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.activeImage.positionOfOrigin[0],
                                    expression:
                                      "activeImage.positionOfOrigin[0]"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  id: "position_of_the_origin_x"
                                },
                                domProps: {
                                  value: _vm.activeImage.positionOfOrigin[0]
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.activeImage.positionOfOrigin,
                                      0,
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.activeImage.positionOfOrigin[1],
                                    expression:
                                      "activeImage.positionOfOrigin[1]"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  id: "position_of_the_origin_y"
                                },
                                domProps: {
                                  value: _vm.activeImage.positionOfOrigin[1]
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.activeImage.positionOfOrigin,
                                      1,
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.activeImage.positionOfOrigin[2],
                                    expression:
                                      "activeImage.positionOfOrigin[2]"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  id: "position_of_the_origin_z"
                                },
                                domProps: {
                                  value: _vm.activeImage.positionOfOrigin[2]
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.activeImage.positionOfOrigin,
                                      2,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeImage.displayType === "Scene"
                  ? _c(
                      "div",
                      { staticClass: "row form-group align-items-center" },
                      [
                        _c(
                          "label",
                          { staticClass: "col-sm-4 col-form-label" },
                          [_vm._v("Rotation of Origin")]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-8" }, [
                          _c(
                            "div",
                            { staticClass: "d-flex align-items-center" },
                            [
                              _c("span", { staticClass: "p-2" }, [_vm._v("x")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.activeImage.rotationOfOrigin[0],
                                    expression:
                                      "activeImage.rotationOfOrigin[0]"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  id: "rotation_of_the_origin_x"
                                },
                                domProps: {
                                  value: _vm.activeImage.rotationOfOrigin[0]
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.activeImage.rotationOfOrigin,
                                      0,
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "p-2" }, [_vm._v("y")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.activeImage.rotationOfOrigin[1],
                                    expression:
                                      "activeImage.rotationOfOrigin[1]"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  id: "rotation_of_the_origin_y"
                                },
                                domProps: {
                                  value: _vm.activeImage.rotationOfOrigin[1]
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.activeImage.rotationOfOrigin,
                                      1,
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "p-2" }, [_vm._v("z")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.activeImage.rotationOfOrigin[2],
                                    expression:
                                      "activeImage.rotationOfOrigin[2]"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  id: "rotation_of_the_origin_z"
                                },
                                domProps: {
                                  value: _vm.activeImage.rotationOfOrigin[2]
                                },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.activeImage.rotationOfOrigin,
                                      2,
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a0fb831", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a0fb831","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/story-edit-view/inspector-components/media-images/maininspector.vue
// module id = null
// module chunks = 